// Field, collection and intent observations (E01-S1-T3; contracts 1.0 section 1).
import { z } from "zod";
import { Count, Id, IsoUtc, NonEmpty, strictObject, version } from "../primitives.js";
import { BandSchema, TokenSchema } from "./values.js";
/**
 * One observed field. A union discriminated on cls; every variant strict, so the numeric variant
 * has no `value` key at all and the identifier variant accepts only a token.
 */
export const FieldObservation = z.discriminatedUnion("cls", [
    strictObject({ cls: z.literal("structural"), value: z.string() }),
    strictObject({ cls: z.literal("enum"), value: z.string() }),
    strictObject({
        cls: z.literal("numeric"),
        present: z.boolean(),
        band: BandSchema.optional(),
        bandIndex: Count.optional(),
    })
        .refine((o) => (o.band === undefined) === (o.bandIndex === undefined), {
        message: "band and bandIndex travel together",
    })
        .refine((o) => o.present || o.band === undefined, {
        message: "an empty numeric field has no band",
    }),
    strictObject({ cls: z.literal("identifier"), token: TokenSchema }),
    strictObject({ cls: z.literal("pii"), masked: z.literal(true) }),
    strictObject({
        cls: z.literal("free-text"),
        masked: z.literal(true),
        present: z.boolean(),
        length: Count,
    }).refine((o) => o.present === o.length > 0, { message: "present means length > 0" }),
]);
/** A grid is read as counts, never rows. */
export const CollectionObservation = strictObject({
    rowCount: Count,
    selectedCount: Count,
    pageSize: Count.optional(),
    page: Count.optional(),
    pages: Count.optional(),
    total: Count.optional(),
}).refine((c) => c.selectedCount <= c.rowCount, {
    message: "selectedCount cannot exceed rowCount",
    path: ["selectedCount"],
});
/** The pointer or focus has reached a declared action's control, before any click. */
export const IntentPhase = z.enum(["hover", "focus"]);
export const IntentEvent = strictObject({
    v: version(1),
    at: IsoUtc,
    sourceId: NonEmpty,
    action: Id,
    phase: IntentPhase,
});
//# sourceMappingURL=observation.js.map